import PropTypes from 'prop-types';
export const infoBarPropTypes = {
    title: PropTypes.string,
    totalInfo: PropTypes.string,
    amountLoan: PropTypes.number,
    hasDiscount: PropTypes.bool,
    discountInfo: PropTypes.string,
    amountWithoutDiscount: PropTypes.number,
    percentageDiscount: PropTypes.string,
    logoUrl: PropTypes.string,
    fractionDigits: PropTypes.number,
    currencyISO: PropTypes.string,
};
export const infoBarDefaultValues = {
    amountWithoutDiscount: 0,
    percentageDiscount: '',
    hasDiscount: false,
    fractionDigits: 0,
    currencyISO: 'COP',
    hideBadgeIcon: false,
};
//# sourceMappingURL=infoBar.prop-types.js.map